import React from 'react';
import './three-dot-loading-animation.scss';

const ThreeDotLoadingAnimation  = () => {

    return <div className={'three-dots-loading'}>
        <div></div>
        <div></div>
        <div></div>
    </div>;
};
export default ThreeDotLoadingAnimation;